export default {"src":"/_next/static/media/logo-ceskatelevize.a5b4c173.svg","height":40,"width":272,"blurWidth":0,"blurHeight":0};